/**
 * Centralized URLs used throughout the application
 */

export const BLOG_URL = 'https://blog.trackplicant.com/';